<ng-container *ngIf="reportState$ | async as reportState">
  <ng-container *ngIf="reportState.providers?.length && !hidden">
    <div class="chart-wrap">
      <div class="row" *ngIf="solidData; else badData" [@dive]="doughnutDiveState">
        <div class="col-6">
          <div class="doughnut-chart-holder">
            <canvas
              #doughnutChart="doughnut-chart"
              appDoughnutChart
              [values]="getChartValues(reportState.providers)"
              width="128"
              height="128"
            ></canvas>
          </div>
        </div>
        <div class="col-6">
          <div class="data-wrap">
            <div class="data-item percentage">{{ formatPercentage(reportState.providers[doughnutRecord]) }}%</div>
            <div class="data-item title">
              {{ reportState.providers[doughnutRecord].name }}
            </div>
          </div>
        </div>
      </div>
      <ng-template #badData>
        <div class="doughnut-bad-data">
          <span i18n="@@providers-table.accountInvoicesBadDoughnutData">There is no chart available for this selection.</span>
        </div>
      </ng-template>
    </div>
    <div class="statistics-table-container">
      <table class="statistics-table">
        <tr
          *ngFor="let record of reportState.providers; let i = index"
          [ngClass]="{ current: selectedRecord === i }"
          [@dive]="{
            value: 'in',
            params: {
              distance: '-40px',
              duration: '200ms',
              easing: 'cubic-bezier(.77, 0, .18, 1)'
            }
          }"
          (click)="selectRecord(i)"
        >
          <td class="pos">{{ i + 1 }}</td>
          <td class="name">{{ record.name }}</td>
          <td class="value">{{ record.value }}</td>
        </tr>
      </table>
    </div>
  </ng-container>
</ng-container>
